function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { method, extendedEvent, composeEventName } from '../support/index';
const defaultOptions = {
  dispatchEvent: true,
  eventPrefix: true
};
export const useIntersection = (controller, options = {}) => {
  const _Object$assign = Object.assign({}, defaultOptions, options),
    dispatchEvent = _Object$assign.dispatchEvent,
    eventPrefix = _Object$assign.eventPrefix;
  const targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
  const callback = entries => {
    const _entries = _slicedToArray(entries, 1),
      entry = _entries[0];
    if (entry.isIntersecting) {
      dispatchAppear(entry);
    } else if (controller.isVisible) {
      dispatchDisappear(entry);
    }
  };
  const dispatchAppear = entry => {
    controller.isVisible = true;
    method(controller, 'appear').call(controller, entry);
    // emit a custom "appear" event
    if (dispatchEvent) {
      const eventName = composeEventName('appear', controller, eventPrefix);
      const appearEvent = extendedEvent(eventName, null, {
        controller,
        entry
      });
      targetElement.dispatchEvent(appearEvent);
    }
  };
  const dispatchDisappear = entry => {
    controller.isVisible = false;
    method(controller, 'disappear').call(controller, entry);
    // emit a custom "disappear" event
    if (dispatchEvent) {
      const eventName = composeEventName('disappear', controller, eventPrefix);
      const disappearEvent = extendedEvent(eventName, null, {
        controller,
        entry
      });
      targetElement.dispatchEvent(disappearEvent);
    }
  };
  // keep a copy of the current disconnect() function of the controller
  // to support composing several behaviors
  const controllerDisconnect = controller.disconnect.bind(controller);
  const observer = new IntersectionObserver(callback, options);
  const observe = () => {
    observer.observe(targetElement);
  };
  const unobserve = () => {
    observer.unobserve(targetElement);
  };
  Object.assign(controller, {
    isVisible: false,
    disconnect() {
      unobserve();
      controllerDisconnect();
    }
  });
  observe();
  return [observe, unobserve];
};